// Vídeo adiado (<deferred-video>): a foto é pôster e o player só nasce
// no clique. Antes disso nenhuma requisição sai para o YouTube, o que
// mantém a página leve e não entrega a visita a terceiros sem motivo.

class DeferredVideo extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-video-play]')?.addEventListener('click', () => this.play(), { once: true });
  }

  // Aceita o endereço que a dona colar: link normal, link curto ou já o
  // de incorporação.
  embedUrl(raw) {
    try {
      const url = new URL(raw);
      const id = url.searchParams.get('v') || url.pathname.split('/').filter(Boolean).pop();
      if (url.hostname.includes('youtu')) {
        return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;
      }
      if (url.hostname.includes('vimeo')) {
        return `https://player.vimeo.com/video/${id}?autoplay=1`;
      }
      return raw;
    } catch {
      return raw;
    }
  }

  play() {
    const src = this.embedUrl(this.dataset.video);
    if (!src) return;

    const frame = document.createElement('iframe');
    frame.src = src;
    frame.title = this.querySelector('[data-video-play] .visually-hidden')?.textContent ?? '';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture';
    frame.allowFullscreen = true;
    this.append(frame);
    this.setAttribute('data-playing', '');
  }
}

if (!customElements.get('deferred-video')) {
  customElements.define('deferred-video', DeferredVideo);
}
